import * as React from 'react';
import { SVGProps } from 'react';

const IconTechResponseSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    <path d="M19.5 12c0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98H7a5 5 0 0 1 10 0h2.5ZM13 17h-2v1.268A2 2 0 0 0 12 22a2 2 0 0 0 1-3.732V17ZM5 15h2v3.268A2 2 0 0 1 6 22a2 2 0 0 1-1-3.732V15ZM18 22a2 2 0 0 0 1-3.732V15h-2v3.268A2 2 0 0 0 18 22Z" />
  </svg>
);
export default IconTechResponseSizeM;
